import type { Store } from './types';

type EntityImage = (id: number | string, type: 'brand' | 'product' | 'retailer') => string;

/** One key for every store of the app's own list, because those stores have no retailer. */
const ownerKey = (store: Store): string => (store.retailerid == null ? 'app' : String(store.retailerid));

/** The identity of a store on the map and in the list: its owner and its address. */
export const storeKey = (store: Store): string =>
  `${ownerKey(store)}-${store.address}-${store.city}-${store.state}-${store.zipcode}`;

export const isSameStore = (a: Store, b: Store): boolean => storeKey(a) === storeKey(b);

/** The server sends the owner logo. An older server sends only the retailer id. */
export const storeLogoUrl = (store: Store, getEntityImage: EntityImage): string | undefined =>
  store.ownerLogoUrl || (store.retailerid == null ? undefined : getEntityImage(store.retailerid, 'retailer'));
